import React from "react";
import "./Featurebanner.css";
import { FaTruck, FaLeaf, FaRecycle, FaCheckCircle,FaShieldAlt  } from "react-icons/fa";

const features = [
  {
    icon: <FaTruck />,
    title: "Free Delivery",
    description: "Enjoy Free Delivery On Eligible Orders",
  },
  {
    icon: <FaLeaf />,
    title: "Fresh & Organic",
    description: "Handpicked daily",
  },
  {
    icon: <FaRecycle />,
    title: "Eco Packaging",
    description: "Biodegradable Materials",
  },
{
  icon: <FaShieldAlt  />,
  title: "Quality Promise",
  description: "Tested for Purity",
}

];

const Featurebanner = () => {
  return (
    <div className="features-banner">
      <div className="features-container">
        {features.map((feature, index) => (
          <div className="feature-item" key={index}>
            <div className="feature-icon">{feature.icon}</div>
            <h5 className="feature-title">{feature.title}</h5>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Featurebanner;
